// /* eslint-disable react/no-array-index-key */
// /* eslint-disable no-else-return */
// /* eslint-disable camelcase */
// /* eslint-disable no-unsafe-optional-chaining */
// /* eslint-disable react/jsx-no-useless-fragment */
// /* eslint-disable react/react-in-jsx-scope */
// /* eslint-disable react/jsx-no-undef */
// import DateFormatter from 'components/DateFormatter';
// import UserInfo from 'components/UserInfo';
// import { isNaN } from 'lodash';
// import moment from 'moment';
// import { Badge } from 'reactstrap';

// export const NumberWithCommasFormat = (number) => {
//   return typeof number === 'number' && !isNaN(number)
//     ? number.toLocaleString()
//     : 'Invalid number';
// };

// export const currencyToLocal = (
//   amount,
//   hs_currency = 'INR',
//   hs_locale = 'en-US',
// ) => {
//   return new Intl.NumberFormat(hs_locale, {
//     style: 'currency',
//     currency: hs_currency,
//   }).format(amount);
// };
// export const showSequenceNumber = (cell, filters) => {
//   const index = cell?.row.index + 1 + (filters?.pageNo - 1) * filters?.pageSize;
//   return index;
// };

// export const ORDER_APPROVAL_STATUS = {
//   ORDER_APPROVAL_PENDING: 'Pending',
//   ORDER_APPROVED: 'Approved',
//   ORDER_REJECTED: 'Rejected',
//   ORDER_APPROVAL_EXPIRED: 'Expired',
// };

// export const TRADER_KYC_STATUS = [
//   { label: 'Pending', value: 'KYC_PENDING' },
//   // { label: "Approved", value: "KYC_APPROVED" },
//   { label: 'Accepted', value: 'KYC_ACCEPTED' },
//   // { label: "Success", value: "KYC_SUCCESS" },
//   { label: 'Suspended', value: 'KYC_REJECTED' },
// ];

// export const TRADER_TDS_ELIGIBLE_STATUS = [
//   { label: 'True', value: true },
//   { label: 'False', value: false },
// ];

// export const OFFER_STATUS = [
//   { label: 'Active', value: 'ACTIVE' },
//   { label: 'Inactive', value: 'INACTIVE' },
//   { label: 'Expired', value: 'EXPIRED' },
//   //   { label: 'Deleted', value: 'DELETED' },
// ];

// export const ORDER_STATUS = [
//   { label: 'Pending', value: 'PENDING' },
//   { label: 'Inprogress', value: 'IN_PROGRESS' },
//   { label: 'Loading', value: 'LOADING' },
//   { label: 'Dispatched', value: 'DISPATCHED' },
//   { label: 'Delivered', value: 'DELIVERED' },
//   // { label: 'Deleted', value: 'DELETED' },
// ];

// export const VENDOR_ORDER_STATUS = {
//   PENDING: 'Pending',
//   IN_PROGRESS: 'Inprogress',
//   LOADING: 'Loading',
//   DISPATCHED: 'Dispatched',
//   DELIVERED: 'Delivered',
// };

// export const PRODUCT_STATUS = [
//   { label: 'Active', value: 'ACTIVE' },
//   { label: 'Inactive', value: 'INACTIVE' },
//   // { label: 'Expired', value: 'EXPIRED' },
//   //   { label: 'Deleted', value: 'DELETED' },
// ];

// export const ADD_EDIT_CONSTANT = {
//   ADD: 'Add',
//   EDIT: 'Edit',
//   UPDATE: 'Update',
// };

// export const VENDOR_TABS = {
//   ALL: 'All',
//   KYC_ACCEPTED: 'KYC Accepted',
//   KYC_PENDING: 'KYC Pending',
//   KYC_REJECTED: 'Suspended',
//   VENDOR_DELETED: 'Deleted',
// };

// export const KYC_STATUS = {
//   ALL: 'All',
//   KYC_ACCEPTED: 'Accepted',
//   KYC_PENDING: 'Pending',
//   KYC_REJECTED: 'Suspended',
//   VENDOR_DELETED: 'Deleted',
// };

// export const TRADER_STATUS = [
//   { label: 'Active', value: 'ACTIVE' },
//   // { label: 'InActive', value: 'INACTIVE' },
//   { label: 'Deleted', value: 'DELETED' },
// ];

// export const SUSPENDED_TRADER_STATUS = [
//   { label: 'Active', value: 'ACTIVE' },
//   { label: 'Suspended', value: 'SUSPENDED' },
// ];

// export const TRADER_INACTIVE_STATUS = [
//   { label: 'Active', value: 'ACTIVE' },
//   { label: 'InActive', value: 'INACTIVE' },
//   // { label: 'Deleted', value: 'DELETED' },
// ];

// export const PAYMENT_STATUS = [
//   { label: 'Unpaid', value: 'UNPAID' },
//   { label: 'Partially Paid', value: 'PARTIALLY_PAID' },
//   { label: 'Fully Paid', value: 'FULLY_PAID' },
// ];

// export const VENDOR_ORDER_SOLD_AND_PURCHASE_TABS = {
//   SOLD: 'Sold',
//   PURCHASED: 'Purchased',
//   PAID: 'Paid',
//   RECEIVED: 'Received',
// };
// export const VENDOR_PAYMENT_TABS = {
//   PAID: 'Paid',
//   RECEIVED: 'Received',
// };

// export const INVOICE_TABS = {
//   ALL: 'All',
//   FULLY_PAID: 'Fully Paid',
//   PARTIALLY_PAID: 'Partially Paid',
//   UNPAID: 'Unpaid',
// };

// export const BID_STATUS = Object.freeze({
//   IN_PROGRESS: 'BID_IN_PROGRESS',
//   ACCEPTED: 'BID_ACCEPTED',
//   REJECTED: 'BID_REJECTED',
//   COUNTER: 'BID_COUNTER',
//   EXPIRED: 'BID_EXPIRED',
//   WITHDRAWN: 'BID_WITHDRAWN',
//   DELETED: 'BID_DELETED',
// });

// export const BIDDING_ORDER_STATUS = {
//   ACTIVE_BIDS: 'Active Bids',
//   EXPIRED_BIDS: 'Expired Bids',
//   COMPLETED_BIDS: 'Completed Bids',
//   ACCEPTED_BIDS: 'Accepted Bids',
//   REJECTED_BIDS: 'Rejected Bids',
//   WITHDRAWN_BIDS: 'Withdrawn Bids',
// };

// export const BIDS_TABS = {
//   ACTIVE_BIDS: 'Active Bids',
//   EXPIRED_BIDS: 'Expired Bids',
//   ACCEPTED_BIDS: 'Accepted Bids',
//   REJECTED_BIDS: 'Rejected Bids',
//   WITHDRAWN_BIDS: 'Withdrawn Bids',
// };

// // const bidsTabToStatusMapping = {
// //   [BIDS_TABS.ACTIVE_BIDS]: BID_STATUS.IN_PROGRESS, // Example, modify as needed
// //   [BIDS_TABS.EXPIRED_BIDS]: BID_STATUS.EXPIRED,
// //   [BIDS_TABS.ACCEPTED_BIDS]: BID_STATUS.ACCEPTED,
// //   [BIDS_TABS.REJECTED_BIDS]: BID_STATUS.REJECTED,
// //   [BIDS_TABS.WITHDRAWN_BIDS]: BID_STATUS.WITHDRAWN,
// // };
// // export const bidsTabStatusArray = Object.entries(bidsTabToStatusMapping).map(
// //   ([label, value]) => ({ label, value }),
// // );

// export const bidsTabStatusArray = [
//   {
//     label: 'Active',
//     value: 'BID_IN_PROGRESS',
//   },
//   {
//     label: 'Expired',
//     value: 'BID_EXPIRED',
//   },
//   {
//     label: 'Accepted',
//     value: 'BID_ACCEPTED',
//   },
//   {
//     label: 'Rejected',
//     value: 'BID_REJECTED',
//   },
//   {
//     label: 'Withdrawn',
//     value: 'BID_WITHDRAWN',
//   },
// ];

// export const vendorColumns = [
//   { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },

//   {
//     accessorKey: '',
//     header: 'VENDOR',
//     cell: ({ row }) => (
//       <UserInfo
//         name={`${row?.original?.firstName} ${
//           row?.original?.lastName ? row?.original?.lastName : ''
//         }`}
//         mobileNumber={`${row?.original?.callingCode?.callingCode}-${row?.original?.phone}`}
//       />
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'tradeName',
//     header: 'BUSINESS NAME',
//     cell: ({ row }) => (
//       <UserInfo
//         name={row?.original?.entityName}
//         gstNumber={row?.original?.tradeGstIn}
//       />
//     ),
//     sort: true,
//   },

//   {
//     accessorKey: 'userDevices?.osType',
//     header: 'OS TYPE',
//     cell: ({ row }) => (
//       <>
//         {row?.original?.userDevices.length > 0
//           ? row?.original?.userDevices.map((device, i) => (
//               <div key={i}> {device?.osType ? device?.osType : 'N/A'}</div>
//             ))
//           : 'N/A'}
//       </>
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'userDevices?.appVersion',
//     header: 'APP VERSION',
//     cell: ({ row }) => (
//       <>
//         {row?.original?.userDevices.length > 0
//           ? row?.original?.userDevices.map((device, i) => (
//               <div key={i}>
//                 {device?.appVersion ? device?.appVersion : 'N/A'}
//               </div>
//             ))
//           : 'N/A'}
//       </>
//     ),
//     sort: true,
//   },
//   // { accessorKey: 'tradeGstIn', header: 'GST', sort: true },
//   {
//     accessorKey: 'createdAt',
//     header: 'CREATED ON',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     sort: true,
//   },
//   {
//     accessorKey: 'kycStatus',
//     header: 'KYC STATUS',
//     sort: true,
//     cell: ({ row }) => KYC_STATUS?.[row?.original?.kycStatus],
//   },
//   { accessorKey: 'actions', header: '', sort: true },
// ];
// export const orderColumns = [
//   { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
//   {
//     accessorKey: 'grade.name',
//     header: 'GRADE',
//     // cell: ({ row }) =>
//     //   row?.original?.grades.map((item) => {
//     //     return (
//     //       <Badge key={item.id} color="primary">
//     //         {item.name}
//     //       </Badge>
//     //     );
//     //   }),
//     cell: ({ row }) => (
//       <Badge color="primary">{row?.original?.grade?.name}</Badge>
//     ),
//     enableSorting: true,
//   },
//   { accessorKey: 'id', header: 'ORDER ID', enableSorting: true },
//   {
//     accessorKey: 'seller',
//     header: 'SELLER',
//     cell: ({ row }) => (
//       <UserInfo
//         name={row?.original?.seller?.entityName}
//         mobileNumber={`${row?.original?.seller?.callingCode?.callingCode}-${row?.original?.seller?.phone}`}
//       />
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'buyer',
//     header: 'BUYER',
//     cell: ({ row }) => (
//       <UserInfo
//         name={row?.original?.buyer?.entityName}
//         mobileNumber={`${row?.original?.buyer?.callingCode?.callingCode}-${row?.original?.buyer?.phone}`}
//       />
//     ),
//     enableSorting: true,
//   },
//   {
//     header: 'LOCATION',
//     id: 'city?.cityName',
//     cell: ({ row }) => (
//       <>
//         <div className="mb-1">
//           {row?.original?.city?.cityName
//             ? row?.original?.city?.cityName
//             : row?.original?.portOfDischarge?.name}
//         </div>
//         <div className="font-manrope text-active text-nowrap">
//           {row?.original?.state?.stateName}
//         </div>
//       </>
//     ),
//     enableSorting: false,
//   },
//   {
//     accessorKey: 'createdAt',
//     header: 'booking date',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'quantity',
//     header: 'ORDERED QTY',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.quantity)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'pendingQuantity',
//     header: 'Pending QTY',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.pendingQuantity)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'rate',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div className="text-nowrap">
//         {`${currencyToLocal(row?.original?.rate, row?.original?.rateUnit?.isoCurrencyCode)}/${row?.original?.quantityUnit}`}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'approvalStatus',
//     header: 'APPROVAL STATUS',
//     cell: ({ row }) => (
//       <div className="text-center">
//         {ORDER_APPROVAL_STATUS?.[row?.original?.approvalStatus]}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'paymentStatus',
//     header: 'Payment Status',
//     cell: ({ row }) => (
//       <div className="text-center">
//         {INVOICE_TABS?.[row?.original?.paymentStatus]}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'status',
//     header: 'STATUS',
//     cell: ({ row }) => (
//       <div> {VENDOR_ORDER_STATUS?.[row?.original?.status]}</div>
//     ),
//     enableSorting: true,
//   },
// ];

// export const bidsColumns = [
//   {
//     accessorKey: 'bidder.firstName',
//     header: 'Buyer',
//     sort: true,
//     cell: ({ getValue }) => {
//       return (
//         <div>
//           {/* {row.getCanExpand() ? (
//             <Button
//               color="link"
//               className="text-decoration-none p-0 text-active"
//               type="button"
//               {...{
//                 onClick: row.getToggleExpandedHandler(),
//                 style: { cursor: 'pointer' },
//               }}
//             >
//               {row.getIsExpanded() ? (
//                 <MdOutlineExpandLess size={20} />
//               ) : (
//                 <MdOutlineExpandMore size={20} />
//               )}
//             </Button>
//           ) : null}{' '} */}
//           {getValue()}
//         </div>
//       );
//     },
//     footer: (props) => props.column.id,
//   },
//   { accessorKey: 'id', header: `Buyer's Bid`, sort: true },
//   { accessorKey: 'offer.offerType', header: `Seller's Bid`, sort: true },
//   {
//     accessorFn: (row) => {
//       const bidStartTime = row?.bidStartTime;
//       const bidExpireTime = row?.bidExpireTime;
//       if (!bidStartTime || !bidExpireTime) return 'N/A';
//       const validity = moment(bidExpireTime).diff(
//         moment(bidStartTime),
//         'minutes',
//       );
//       return <div className="px-1">{validity} </div>;
//     },
//     cell: (info) => info.getValue(),
//     header: 'Validity(Min)',
//     enableSorting: true,
//   },
//   // {
//   //   accessorFn: (row) => {
//   //     const updatedAt = row?.updatedAt;
//   //     if (!updatedAt) return 'N/A';
//   //     const formated = moment(updatedAt).format('LLL');
//   //     return <div className="px-1">{formated} </div>;
//   //   },
//   //   cell: (info) => info.getValue(),
//   //   header: 'Last update',
//   //   sort: true,
//   // },

//   {
//     accessorKey: 'updatedAt',
//     header: 'Last update',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.updatedAt} />,
//     enableSorting: false,
//   },
// ];

// export const activeAndInactivebidsColumns = [
//   // {
//   //   accessorKey: 'allBids.bidder.firstName',
//   //   header: 'Buyer',
//   //   sort: true,
//   //   cell: ({ getValue }) => {
//   //     return (
//   //       <div>
//   //         {/* {row.getCanExpand() ? (
//   //           <Button
//   //             color="link"
//   //             className="text-decoration-none p-0 text-active"
//   //             type="button"
//   //             {...{
//   //               onClick: row.getToggleExpandedHandler(),
//   //               style: { cursor: 'pointer' },
//   //             }}
//   //           >
//   //             {row.getIsExpanded() ? (
//   //               <MdOutlineExpandLess size={20} />
//   //             ) : (
//   //               <MdOutlineExpandMore size={20} />
//   //             )}
//   //           </Button>
//   //         ) : null}{' '} */}
//   //         {getValue()}
//   //       </div>
//   //     );
//   //   },
//   //   footer: (props) => props.column.id,
//   // },
//   { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
//   {
//     accessorFn: (row) => {
//       return row?.latestBid?.bidType === 'OFFER' ? (
//         <UserInfo
//           name={row?.latestBid?.offer?.trader?.entityName}
//           mobileNumber={`${row?.latestBid?.offer?.trader?.callingCode?.callingCode}-${row?.latestBid?.offer?.trader?.phone}`}
//         />
//       ) : (
//         <UserInfo
//           name={row?.latestBid?.demand?.trader?.entityName}
//           mobileNumber={`${row?.latestBid?.demand?.trader?.callingCode?.callingCode}-${row?.latestBid?.demand?.trader?.phone}`}
//         />
//       );
//     },
//     header: 'seller',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.latestBid?.bidType === 'OFFER' ? (
//         <UserInfo
//           name={row?.latestBid?.bidder?.entityName}
//           mobileNumber={`${row?.latestBid?.bidder?.callingCode?.callingCode}-${row?.latestBid?.bidder?.phone}`}
//         />
//       ) : (
//         <UserInfo
//           name={row?.latestBid?.bidder?.entityName}
//           mobileNumber={`${row?.latestBid?.bidder?.callingCode?.callingCode}-${row?.latestBid?.bidder?.phone}`}
//         />
//       );
//     },
//     header: 'Last Bidder',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.latestBid?.bidType === 'OFFER'
//         ? row?.latestBid?.offer?.grades?.map((item) => {
//             return (
//               <Badge key={item.id} color="primary">
//                 {item?.name}
//               </Badge>
//             );
//           })
//         : row?.latestBid?.demand?.grades?.map((item) => {
//             return (
//               <Badge key={item.id} color="primary">
//                 {item?.name}
//               </Badge>
//             );
//           });
//     },
//     header: 'grade',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.latestBid?.bidType === 'OFFER' ? (
//         <>
//           <div className="mb-1 text-nowrap">
//             {row?.latestBid?.offer?.city?.cityName
//               ? row?.latestBid?.offer?.city?.cityName
//               : row?.latestBid?.offer?.portsOfDischarge?.map(
//                   (portOfDischarge) => {
//                     return (
//                       <div key={portOfDischarge?.id} className="me-1">
//                         {`${portOfDischarge?.name},` || 'Not Available'}
//                       </div>
//                     );
//                   },
//                 )}
//           </div>
//           <div className="font-manrope text-active">
//             {row?.latestBid?.offer?.state?.stateName}
//           </div>
//         </>
//       ) : (
//         <>
//           <div className="mb-1 text-nowrap">
//             {row?.latestBid?.demand?.city?.cityName
//               ? row?.latestBid?.demand?.city?.cityName
//               : row?.latestBid?.demand?.portsOfDischarge?.map(
//                   (portOfDischarge) => {
//                     return (
//                       <div key={portOfDischarge?.id} className="me-1">
//                         {`${portOfDischarge?.name},` || 'Not Available'}
//                       </div>
//                     );
//                   },
//                 )}
//           </div>
//           <div className="font-manrope text-active">
//             {row?.latestBid?.demand?.state?.stateName}
//           </div>
//         </>
//       );
//     },
//     header: 'Location',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.latestBid?.bidType === 'OFFER'
//         ? `${NumberWithCommasFormat(row?.latestBid?.offer?.totalQty)} ${row?.latestBid?.offer?.actualQuantityUnit || row?.latestBid?.offer?.quantityUnit}`
//         : `${NumberWithCommasFormat(row?.latestBid?.demand?.totalQty)} ${row?.latestBid?.demand?.actualQuantityUnit || row?.latestBid?.demand?.quantityUnit}`;
//     },
//     header: 'total QTY',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.latestBid?.bidType === 'OFFER'
//         ? `${NumberWithCommasFormat(row?.latestBid?.offer?.minimumQty)} ${row?.latestBid?.offer?.actualQuantityUnit || row?.latestBid?.offer?.quantityUnit} `
//         : `${NumberWithCommasFormat(row?.latestBid?.demand?.minimumQty)} ${row?.latestBid?.demand?.actualQuantityUnit || row?.latestBid?.demand?.quantityUnit}`;
//     },
//     header: 'min. QTY',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },

//   {
//     accessorFn: (row) => {
//       return (
//         <div className="px-1 text-nowrap">
//           {row?.latestBid?.bidType === 'OFFER'
//             ? `${currencyToLocal(
//                 row?.latestBid?.offer?.rate,
//                 row?.latestBid?.rateUnit?.isoCurrencyCode,
//               )}/${row?.latestBid?.offer?.quantityUnit}`
//             : `${currencyToLocal(
//                 row?.latestBid?.demand?.rate,
//                 row?.latestBid?.rateUnit?.isoCurrencyCode,
//               )}/${row?.latestBid?.demand?.quantityUnit}`}
//         </div>
//       );
//     },
//     header: 'rate',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   // { accessorKey: 'latestBid.id', header: 'Bid ID', enableSorting: true },
//   // { accessorKey: 'latestBid.bidderRole', header: 'Role', enableSorting: true },
//   {
//     accessorFn: (row) => {
//       return (
//         <div className="px-1 text-nowrap">
//           {`${currencyToLocal(
//             row?.latestBid?.price,
//             row?.latestBid?.rateUnit?.isoCurrencyCode,
//           )}/${row?.latestBid?.quantityUnit}`}
//         </div>
//       );
//     },
//     cell: (info) => info.getValue(),
//     header: 'Bid Rate',
//     enableSorting: true,
//   },
//   {
//     accessorFn: (row) => {
//       return (
//         <div className="px-1">
//           {NumberWithCommasFormat(row?.latestBid?.quantity)}{' '}
//           {row?.latestBid?.quantityUnit}{' '}
//         </div>
//       );
//     },
//     cell: (info) => info.getValue(),
//     header: 'bid Quantity',
//     enableSorting: true,
//   },
//   {
//     accessorFn: (row) => {
//       return <DateFormatter dateTime={row?.latestBid?.bidExpireTime} />;
//     },
//     cell: (info) => info.getValue(),
//     header: 'Bid Expire time',
//     enableSorting: true,
//   },
//   { accessorKey: 'latestBid.bidType', header: 'Type', enableSorting: true },

//   // { accessorKey: 'offer.offerType', header: `Seller's Bid`,    enableSorting: false, },
//   // {
//   //   accessorFn: (row) => {
//   //     const bidStartTime = row?.bidStartTime;
//   //     const bidExpireTime = row?.bidExpireTime;
//   //     if (!bidStartTime || !bidExpireTime) return 'N/A';
//   //     const validity = moment(bidExpireTime).diff(
//   //       moment(bidStartTime),
//   //       'minutes'
//   //     );
//   //     return <div className="px-1">{validity} </div>;
//   //   },
//   //   cell: (info) => info.getValue(),
//   //   header: 'Validity(Min)',
//   //   enableSorting: true,
//   // },
//   // {
//   //   accessorFn: (row) => {
//   //     const updatedAt = row?.updatedAt;
//   //     if (!updatedAt) return 'N/A';
//   //     const formated = moment(updatedAt).format('LLL');
//   //     return <div className="px-1">{formated} </div>;
//   //   },
//   //   cell: (info) => info.getValue(),
//   //   header: 'Last update',
//   //   sort: true,
//   // },

//   // {
//   //   accessorKey: 'updatedAt',
//   //   header: 'Last update',
//   //   cell: ({ row }) => (
//   //     <DateFormatter dateTime={row?.original?.latestBid?.updatedAt} />
//   //   ),
//   //   enableSorting: false,
//   // },
// ];

// export const childBidsColumns = [
//   // { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
//   // { accessorKey: 'bidType', header: 'Type', enableSorting: true },
//   {
//     accessorFn: (row) => {
//       return row?.bidType === 'OFFER' ? (
//         <UserInfo
//           name={row?.offer?.trader?.entityName}
//           mobileNumber={`${row?.offer?.trader?.callingCode?.callingCode}-${row?.offer?.trader?.phone}`}
//         />
//       ) : (
//         <UserInfo
//           name={row?.demand?.trader?.entityName}
//           mobileNumber={`${row?.demand?.trader?.callingCode?.callingCode}-${row?.demand?.trader?.phone}`}
//         />
//       );
//     },
//     header: 'seller',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.bidType === 'OFFER' ? (
//         <UserInfo
//           name={row?.bidder?.entityName}
//           mobileNumber={`${row?.bidder?.callingCode?.callingCode}-${row?.bidder?.phone}`}
//         />
//       ) : (
//         <UserInfo
//           name={row?.bidder?.entityName}
//           mobileNumber={`${row?.bidder?.callingCode?.callingCode}-${row?.bidder?.phone}`}
//         />
//       );
//     },
//     header: 'Bidder',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.bidType === 'OFFER'
//         ? row?.offer?.grades?.map((item) => {
//             return (
//               <Badge key={item.id} color="primary">
//                 {item.name}
//               </Badge>
//             );
//           })
//         : row?.demand?.grades?.map((item) => {
//             return (
//               <Badge key={item.id} color="primary">
//                 {item?.name}
//               </Badge>
//             );
//           });
//     },
//     header: 'grade',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.bidType === 'OFFER' ? (
//         <>
//           <div className="mb-1 text-nowrap">
//             {row?.offer?.city?.cityName
//               ? row?.offer?.city?.cityName
//               : row?.offer?.portsOfDischarge?.map((portOfDischarge) => {
//                   return (
//                     <div key={portOfDischarge?.id} className="me-1">
//                       {`${portOfDischarge?.name},` || 'Not Available'}
//                     </div>
//                   );
//                 })}
//           </div>
//           <div className="font-manrope text-active">
//             {row?.offer?.state?.stateName}
//           </div>
//         </>
//       ) : (
//         <>
//           <div className="mb-1 text-nowrap">
//             {row?.demand?.city?.cityName
//               ? row?.demand?.city?.cityName
//               : row?.demand?.portsOfDischarge?.map((portOfDischarge) => {
//                   return (
//                     <div key={portOfDischarge?.id} className="me-1">
//                       {`${portOfDischarge?.name},` || 'Not Available'}
//                     </div>
//                   );
//                 })}
//           </div>
//           <div className="font-manrope text-active">
//             {row?.demand?.state?.stateName}
//           </div>
//         </>
//       );
//     },
//     header: 'Location',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.bidType === 'OFFER'
//         ? `${NumberWithCommasFormat(row?.offer?.totalQty)} ${row?.offer?.actualQuantityUnit || row?.offer?.quantityUnit}`
//         : `${NumberWithCommasFormat(row?.demand?.totalQty)} ${row?.demand?.actualQuantityUnit || row?.demand?.quantityUnit}`;
//     },
//     header: 'total QTY',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorFn: (row) => {
//       return row?.bidType === 'OFFER'
//         ? `${NumberWithCommasFormat(row?.offer?.minimumQty)} ${row?.offer?.actualQuantityUnit || row?.offer?.quantityUnit}`
//         : `${NumberWithCommasFormat(row?.demand?.minimumQty)} ${row?.demand?.actualQuantityUnit || row?.demand?.quantityUnit}`;
//     },
//     header: 'min. QTY',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },

//   {
//     accessorFn: (row) => {
//       return (
//         <div className="px-1 text-nowrap">
//           {row?.bidType === 'OFFER'
//             ? `${currencyToLocal(row?.offer?.rate, row?.rateUnit?.isoCurrencyCode)}/${row?.offer?.quantityUnit}`
//             : `${currencyToLocal(row?.demand?.rate, row?.rateUnit?.isoCurrencyCode)}/${row?.demand?.quantityUnit}`}
//         </div>
//       );
//     },
//     header: 'rate',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   // { accessorKey: 'latestBid.id', header: 'Bid ID', enableSorting: true },
//   // { accessorKey: 'latestBid.bidderRole', header: 'Role', enableSorting: true },
//   {
//     accessorFn: (row) => {
//       return (
//         <div className="px-1 text-nowrap">
//           {`${currencyToLocal(row?.price, row?.rateUnit?.isoCurrencyCode)}/
//           ${row?.quantityUnit}`}
//         </div>
//       );
//     },
//     cell: (info) => info.getValue(),
//     header: 'Bid Rate',
//     enableSorting: true,
//   },
//   {
//     accessorFn: (row) => {
//       return (
//         <div className="px-1">
//           {NumberWithCommasFormat(row?.quantity)} {row?.quantityUnit}{' '}
//         </div>
//       );
//     },
//     cell: (info) => info.getValue(),
//     header: 'bid Quantity',
//     enableSorting: true,
//   },
//   {
//     accessorFn: (row) => {
//       return <DateFormatter dateTime={row?.bidExpireTime} />;
//     },
//     cell: (info) => info.getValue(),
//     header: 'Bid Expire time',
//     enableSorting: true,
//   },
// ];

// export const INVOICE_STATUS = {
//   INVOICE_UNPAID: 'Unpaid',
//   PAID_PARTIAL: 'Partially paid',
//   PAID_FULL: 'Fully paid',
// };

// export const invoicesListCategoryColumns = [
//   { accessorKey: 'id', header: 'INVOICE ID', sort: true },
//   {
//     accessorKey: 'createdAt',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     header: 'DATE',
//     sort: true,
//   },
//   {
//     accessorFn: (row) => {
//       return <div className="mb-1">{row?.order?.buyer?.tradeName}</div>;
//     },
//     header: 'BILLED TO',
//     id: 'order.buyer.tradeName',
//     enableSorting: true,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: 'invoiceStatus',
//     header: 'PAYMENT',
//     sort: true,
//     cell: ({ row }) => (
//       <div>{INVOICE_STATUS?.[row?.original?.invoiceStatus]}</div>
//     ),
//   },
//   {
//     accessorKey: 'total',
//     header: 'AMOUNT',
//     sort: true,
//     cell: (cell) => {
//       return <span>&#8377;{cell?.row?.original?.total}</span>;
//     },
//   },
//   { accessorKey: 'actions', header: '', sort: true },
// ];

// export const orderStatusColors = Object.freeze({
//   LOADING: '#c71dff',
//   PENDING: '#ffe100',
//   DISPATCHED: '#f47000',
//   IN_PROGRESS: '#692ef4',
//   DELIVERED: '#e40000',
// });

// export const orderStatusLabel = Object.freeze({
//   LOADING: 'Loading',
//   PENDING: 'Pending',
//   DISPATCHED: 'Dispatched',
//   IN_PROGRESS: 'In_Progress',
//   DELIVERED: 'Delivered',
// });

// export const BidOrderType = Object.freeze({
//   OFFER: 'OFFER',
//   DEMAND: 'DEMAND',
//   ALL: 'ALL',
// });

// export const VENDOR_ORDER_TABS = {
//   ALL: 'All',
//   FULLY_PAID: 'Fully Paid',
//   PARTIALLY_PAID: 'Partially Paid',
//   PENDING: 'Pending',
// };

// export const VENDOR_ORDERS_TABS = {
//   SOLD_AND_PURCHASE: 'Sold And Purchase',
//   PAYMENT: 'Paid Payment',
// };

// export const VENDOR_ORDER_PAYMENT_TABS = {
//   PARTIALLY_PAID: 'Partially Paid',
//   FULLY_PAID: 'Fully Paid',
//   UNPAID: 'Unpaid',
// };

// export const VENDOR_BIDS_TABS = {
//   OFFER: 'Offer',
//   MY_OFFER: 'My Offers',
//   OTHER_OFFER: 'Other Offers',
//   DEMAND: 'Demand',
//   MY_DEMAND: 'My Demands',
//   OTHER_DEMAND: 'Other Demands',
// };

// export const defaultDeleteFilter = {
//   key: 'isDeleted',
//   value: 'true',
//   type: 'BOOLEAN',
//   op: 'NEQ',
// };

// export const dynamicButtonHeading = (type) => {
//   return type === ADD_EDIT_CONSTANT.EDIT ? 'Update' : 'Add';
// };

// export const invoicesColumns = [
//   // { accessorKey: 'name', header: 'CATEGORY', sort: true },
//   // { accessorKey: 'invoiceDate', header: 'CREATED ON', sort: true },
//   // { accessorKey: 'invoiceStatus', header: 'STATUS', sort: true },
//   { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },

//   {
//     accessorFn: (row) => {
//       return <div className="mb-1">{row?.order?.buyer?.tradeName}</div>;
//     },
//     header: 'BILLED TO',
//     id: 'order.buyer.tradeName',
//     enableSorting: false,
//     cell: (info) => info.getValue(),
//   },
//   { accessorKey: 'id', header: 'INVOICE ID', enableSorting: true },
//   {
//     accessorKey: 'invoiceStatus',
//     header: 'PAYMENT',
//     cell: ({ row }) => (
//       <div>{INVOICE_STATUS?.[row?.original?.invoiceStatus]}</div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'total',
//     header: 'AMOUNT',
//     cell: ({ row }) => (
//       <div>
//         {currencyToLocal(
//           row?.original?.total,
//           row?.original?.rateUnit?.isoCurrencyCode,
//         )}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'createdAt',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     header: 'DATE',
//     enableSorting: true,
//   },
// ];

// export const quantityUnitData = [
//   { id: 'KG', label: 'KG' },
//   { id: 'MT', label: 'MT' },
// ];

// export const currencyUnitData = [
//   { id: 101, label: 'INR' },
//   { id: 233, label: 'USD' },
// ];

// export const orderStatus = [
//   {
//     LOADING: 'Loading',
//     PENDING: 'Pending',
//     DISPATCHED: 'Dispatched',
//     IN_PROGRESS: 'InProgress',
//     DELIVERED: 'Delivered',
//     CANCELLED: 'Cancelled',
//   },
// ];

// export const PASSWORD_REGEX =
//   /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{6,16}$/;

// export const PASSWORD_REGEX_MESSAGE =
//   'Password must contain at least one digit, one lowercase letter, one uppercase letter, one special character, and be between 6 and 16 characters long.';

// export const modifiedUnderScore = (originalString) => {
//   if (originalString) return originalString?.replace(/_/g, ' ');
//   return originalString;
// };

// export const USER_ID = {
//   CREATED_ID: 'createdByUserId',
//   UPDATED_ID: 'updatedByUserId',
// };

// export const allowedUserChecker = (roles, allowedRoles) =>
//   allowedRoles.some((allowedRole) =>
//     roles?.some((role) => role.name === allowedRole),
//   );

// // export const allowedUserChecker = (roles, allowedRoles) =>
// //   allowedRoles.includes(roles);

// export const currentDateToEpoch = () => {
//   return Math.floor(new Date().getTime() / 1000);
// };

// export const currentDatePlusDaysToEpoch = (days = 0) => {
//   const currentDate = new Date();
//   const futureDate = new Date(
//     currentDate.getTime() + days * 24 * 60 * 60 * 1000,
//   );
//   return Math.floor(futureDate.getTime());
//   // return Math.floor(futureDate.getTime() / 1000);
// };

// // export const NumberWithCommasFormat = (number) => {
// //   return typeof number === 'number' && !isNaN(number)
// //     ? number.toLocaleString()
// //     : 'Invalid number';
// // };

// // export const currencyToLocal = (
// //   amount,
// //   hs_currency = 'INR',
// //   hs_locale = 'en-US',
// // ) => {
// //   return new Intl.NumberFormat(hs_locale, {
// //     style: 'currency',
// //     currency: hs_currency,
// //   }).format(amount);
// // };

// export const handlePaymentStatusColor = (value) => {
//   if (value === 'FULLY_PAID') {
//     return 'success';
//   } else if (value === 'UNPAID') {
//     return 'reject';
//   }
// };

// export const handleStatusColor = (value) => {
//   if (value === 'ACTIVE') {
//     return 'success';
//   } else if (value === 'INACTIVE') {
//     return 'reject';
//   }
// };

// export const handleKycStatusColor = (value) => {
//   if (value === 'KYC_ACCEPTED') {
//     return 'success';
//   } else if (value === 'KYC_REJECTED') {
//     return 'reject';
//   }
// };

// export const isGstNumberAvailable = (gstNumber) => {
//   if (!gstNumber) return false;

//   const invalidGstValues = [
//     'Not Available',
//     'N/A',
//     'NA',
//     'null',
//     'undefined',
//     'not available',
//     'n/a'
//   ];

//   return !invalidGstValues.includes(gstNumber.toString().trim()) &&
//          gstNumber.toString().trim().length > 0;
// };

// export const validateGstForKyc = (gstNumber) => {
//   if (!gstNumber) {
//     console.log('❌ GST Validation Failed: No GST number');
//     return false;
//   }

//   const gstStr = gstNumber.toString().trim();

//   const invalidGstValues = [
//     'Not Available',
//     'N/A',
//     'NA',
//     'null',
//     'undefined',
//     'not available',
//     'n/a',
//     '',
//     ' ',
//     '-',
//     '--',
//     'null',
//     'undefined'
//   ];

//   const isValid = !invalidGstValues.includes(gstStr) && gstStr.length > 0;

//   console.log(`🔍 GST Validation:`, {
//     gstNumber: gstStr,
//     isValid,
//     length: gstStr.length
//   });

//   return isValid;
// };

import React from 'react';
import DateFormatter from 'components/DateFormatter';
import UserInfo from 'components/UserInfo';
import { isNaN } from 'lodash';
import moment from 'moment';
import { Badge } from 'reactstrap';
import './childui.css';

export const NumberWithCommasFormat = (number) => {
  return typeof number === 'number' && !isNaN(number)
    ? number.toLocaleString()
    : 'Invalid number';
};

export const currencyToLocal = (
  amount,
  hsCurrency = 'INR',
  hsLocale = 'en-US',
) => {
  return new Intl.NumberFormat(hsLocale, {
    style: 'currency',
    currency: hsCurrency,
  }).format(amount);
};

export const showSequenceNumber = (cell, filters) => {
  const rowIndex = cell?.row?.index ?? 0;
  const pageNo = filters?.pageNo ?? 1;
  const pageSize = filters?.pageSize ?? 10;

  return rowIndex + 1 + (pageNo - 1) * pageSize;
};

export const ORDER_APPROVAL_STATUS = {
  ORDER_APPROVAL_PENDING: 'Pending',
  ORDER_APPROVED: 'Approved',
  ORDER_REJECTED: 'Rejected',
  ORDER_APPROVAL_EXPIRED: 'Expired',
};

export const TRADER_KYC_STATUS = [
  { label: 'Pending', value: 'KYC_PENDING' },
  // { label: "Approved", value: "KYC_APPROVED" },
  { label: 'Accepted', value: 'KYC_ACCEPTED' },
  // { label: "Success", value: "KYC_SUCCESS" },
  { label: 'Suspended', value: 'KYC_REJECTED' },
];

export const TRADER_TDS_ELIGIBLE_STATUS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const OFFER_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Expired', value: 'EXPIRED' },
  //   { label: 'Deleted', value: 'DELETED' },
];

export const ORDER_STATUS = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'In_Progress', value: 'IN_PROGRESS' },
  { label: 'Loading', value: 'LOADING' },
  { label: 'Dispatched', value: 'DISPATCHED' },
  { label: 'Delivered', value: 'DELIVERED' },
];

export const VENDOR_ORDER_STATUS = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In_Progress',
  LOADING: 'Loading',
  DISPATCHED: 'Dispatched',
  DELIVERED: 'Delivered',
};

export const PRODUCT_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  // { label: 'Expired', value: 'EXPIRED' },
  //   { label: 'Deleted', value: 'DELETED' },
];

export const ADD_EDIT_CONSTANT = {
  ADD: 'Add',
  EDIT: 'Edit',
  UPDATE: 'Update',
};

export const VENDOR_TABS = {
  ALL: 'All',
  KYC_ACCEPTED: 'KYC Accepted',
  KYC_PENDING: 'KYC Pending',
  KYC_REJECTED: 'Suspended',
  VENDOR_DELETED: 'Deleted',
};

export const KYC_STATUS = {
  ALL: 'All',
  KYC_ACCEPTED: 'Accepted',
  KYC_PENDING: 'Pending',
  KYC_REJECTED: 'Suspended',
  VENDOR_DELETED: 'Deleted',
};

export const TRADER_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  // { label: 'InActive', value: 'INACTIVE' },
  { label: 'Deleted', value: 'DELETED' },
];

export const SUSPENDED_TRADER_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Suspended', value: 'SUSPENDED' },
];

export const TRADER_INACTIVE_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'InActive', value: 'INACTIVE' },
  // { label: 'Deleted', value: 'DELETED' },
];

export const PAYMENT_STATUS = [
  { label: 'Unpaid', value: 'UNPAID' },
  { label: 'Partially Paid', value: 'PARTIALLY_PAID' },
  { label: 'Fully Paid', value: 'FULLY_PAID' },
];

export const VENDOR_ORDER_SOLD_AND_PURCHASE_TABS = {
  SOLD: 'Sold',
  PURCHASED: 'Purchased',
  PAID: 'Paid',
  RECEIVED: 'Received',
};
export const VENDOR_PAYMENT_TABS = {
  PAID: 'Paid',
  RECEIVED: 'Received',
};

export const INVOICE_TABS = {
  ALL: 'All',
  FULLY_PAID: 'Fully Paid',
  PARTIALLY_PAID: 'Partially Paid',
  UNPAID: 'Unpaid',
};

export const BID_STATUS = Object.freeze({
  IN_PROGRESS: 'BID_IN_PROGRESS',
  ACCEPTED: 'BID_ACCEPTED',
  REJECTED: 'BID_REJECTED',
  COUNTER: 'BID_COUNTER',
  EXPIRED: 'BID_EXPIRED',
  WITHDRAWN: 'BID_WITHDRAWN',
  DELETED: 'BID_DELETED',
});

export const BIDDING_ORDER_STATUS = {
  ACTIVE_BIDS: 'Active Bids',
  EXPIRED_BIDS: 'Expired Bids',
  COMPLETED_BIDS: 'Completed Bids',
  ACCEPTED_BIDS: 'Accepted Bids',
  REJECTED_BIDS: 'Rejected Bids',
  WITHDRAWN_BIDS: 'Withdrawn Bids',
};

export const BID_STATUS_SORT_ORDER = {
  BID_IN_PROGRESS: 1,
  BID_ACTIVE: 1,
  BID_EXPIRED: 2,
  BID_ACCEPTED: 3,
  BID_REJECTED: 4,
  BID_WITHDRAWN: 5,
};

export const BIDS_TABS = {
  ACTIVE_BIDS: 'Active Bids',
  EXPIRED_BIDS: 'Expired Bids',
  ACCEPTED_BIDS: 'Accepted Bids',
  REJECTED_BIDS: 'Rejected Bids',
  WITHDRAWN_BIDS: 'Withdrawn Bids',
};

export const bidsTabStatusArray = [
  {
    label: 'Active',
    value: 'BID_IN_PROGRESS',
  },
  {
    label: 'Expired',
    value: 'BID_EXPIRED',
  },
  {
    label: 'Accepted',
    value: 'BID_ACCEPTED',
  },
  {
    label: 'Rejected',
    value: 'BID_REJECTED',
  },
  {
    label: 'Withdrawn',
    value: 'BID_WITHDRAWN',
  },
];

export const vendorColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },

  {
    accessorKey: '',
    header: 'VENDOR',
    cell: ({ row }) => (
      <UserInfo
        name={`${row?.original?.firstName} ${
          row?.original?.lastName ? row?.original?.lastName : ''
        }`}
        mobileNumber={`${row?.original?.callingCode?.callingCode}-${row?.original?.phone}`}
      />
    ),
    sort: true,
  },
  {
    accessorKey: 'tradeName',
    header: 'BUSINESS NAME',
    cell: ({ row }) => (
      <UserInfo
        name={row?.original?.entityName}
        gstNumber={row?.original?.tradeGstIn}
      />
    ),
    sort: true,
  },

  {
    accessorKey: 'userDevices?.osType',
    header: 'OS TYPE',
    cell: ({ row }) => {
      if (row?.original?.userDevices.length > 0) {
        return row?.original?.userDevices.map((device) => (
          <div key={device?.id || device?.deviceId}>
            {' '}
            {device?.osType || 'N/A'}
          </div>
        ));
      }
      return 'N/A';
    },
    sort: true,
  },
  {
    accessorKey: 'userDevices?.appVersion',
    header: 'APP VERSION',
    cell: ({ row }) => {
      if (row?.original?.userDevices.length > 0) {
        return row?.original?.userDevices.map((device) => (
          <div key={device?.id || device?.deviceId || Math.random()}>
            {device?.appVersion ? device?.appVersion : 'N/A'}
          </div>
        ));
      }
      return 'N/A';
    },
    sort: true,
  },
  // { accessorKey: 'tradeGstIn', header: 'GST', sort: true },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    sort: true,
  },
  {
    accessorKey: 'kycStatus',
    header: 'KYC STATUS',
    sort: true,
    cell: ({ row }) => KYC_STATUS?.[row?.original?.kycStatus],
  },
  { accessorKey: 'actions', header: '', sort: true },
];
export const orderColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'grade.name',
    header: 'GRADE',
    cell: ({ row }) => (
      <Badge color="primary">{row?.original?.grade?.name}</Badge>
    ),
    enableSorting: true,
  },
  { accessorKey: 'id', header: 'ORDER ID', enableSorting: true },
  {
    accessorKey: 'seller',
    header: 'SELLER',
    cell: ({ row }) => (
      <UserInfo
        name={row?.original?.seller?.entityName}
        mobileNumber={`${row?.original?.seller?.callingCode?.callingCode}-${row?.original?.seller?.phone}`}
      />
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'buyer',
    header: 'BUYER',
    cell: ({ row }) => (
      <UserInfo
        name={row?.original?.buyer?.entityName}
        mobileNumber={`${row?.original?.buyer?.callingCode?.callingCode}-${row?.original?.buyer?.phone}`}
      />
    ),
    enableSorting: true,
  },
  {
    header: 'LOCATION',
    id: 'city?.cityName',
    cell: ({ row }) => {
      return (
        <>
          <div className="mb-1">
            {row?.original?.city?.cityName
              ? row?.original?.city?.cityName
              : row?.original?.portOfDischarge?.name}
          </div>
          <div className="font-manrope text-active text-nowrap">
            {row?.original?.state?.stateName}
          </div>
        </>
      );
    },
    enableSorting: false,
  },
  {
    accessorKey: 'createdAt',
    header: 'booking date',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
  {
    accessorKey: 'quantity',
    header: 'ORDERED QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.quantity)}
        {row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'pendingQuantity',
    header: 'Pending QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.pendingQuantity)}
        {row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'rate',
    header: 'RATE',
    cell: ({ row }) => (
      <div className="text-nowrap">
        {`${currencyToLocal(row?.original?.rate, row?.original?.rateUnit?.isoCurrencyCode)}/${row?.original?.quantityUnit}`}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'approvalStatus',
    header: 'APPROVAL STATUS',
    cell: ({ row }) => (
      <div className="text-center">
        {ORDER_APPROVAL_STATUS?.[row?.original?.approvalStatus]}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'paymentStatus',
    header: 'Payment Status',
    cell: ({ row }) => (
      <div className="text-center">
        {INVOICE_TABS?.[row?.original?.paymentStatus]}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'status',
    header: 'STATUS',
    cell: ({ row }) => (
      <div> {VENDOR_ORDER_STATUS?.[row?.original?.status]}</div>
    ),
    enableSorting: true,
  },
];

export const bidsColumns = [
  {
    accessorKey: 'bidder.firstName',
    header: 'Buyer',
    sort: true,
    cell: ({ getValue }) => {
      return <div>{getValue()}</div>;
    },
    footer: (props) => props.column.id,
  },
  { accessorKey: 'id', header: `Buyer's Bid`, sort: true },
  { accessorKey: 'offer.offerType', header: `Seller's Bid`, sort: true },
  {
    accessorFn: (row) => {
      const bidStartTime = row?.bidStartTime ?? null;
      const bidExpireTime = row?.bidExpireTime ?? null;

      if (!bidStartTime || !bidExpireTime) {
        return 'N/A';
      }

      const start = moment(bidStartTime);
      const end = moment(bidExpireTime);

      if (!start.isValid() || !end.isValid()) {
        return 'N/A';
      }

      const validity = end.diff(start, 'minutes');

      return validity;
    },
    cell: (info) => <div className="px-1">{info.getValue()}</div>,
    header: 'Validity (Min)',
    enableSorting: true,
  },

  {
    accessorKey: 'updatedAt',
    header: 'Last update',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.updatedAt} />,
    enableSorting: false,
  },
];

export const activeAndInactivebidsColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorFn: (row) => {
      return row?.latestBid?.bidType === 'OFFER' ? (
        <UserInfo
          name={row?.latestBid?.offer?.trader?.entityName}
          mobileNumber={`${row?.latestBid?.offer?.trader?.callingCode?.callingCode}-${row?.latestBid?.offer?.trader?.phone}`}
        />
      ) : (
        <UserInfo
          name={row?.latestBid?.demand?.trader?.entityName}
          mobileNumber={`${row?.latestBid?.demand?.trader?.callingCode?.callingCode}-${row?.latestBid?.demand?.trader?.phone}`}
        />
      );
    },
    header: 'SELLER',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => {
      return row?.latestBid?.bidType === 'OFFER' ? (
        <UserInfo
          name={row?.latestBid?.bidder?.entityName}
          mobileNumber={`${row?.latestBid?.bidder?.callingCode?.callingCode}-${row?.latestBid?.bidder?.phone}`}
        />
      ) : (
        <UserInfo
          name={row?.latestBid?.bidder?.entityName}
          mobileNumber={`${row?.latestBid?.bidder?.callingCode?.callingCode}-${row?.latestBid?.bidder?.phone}`}
        />
      );
    },
    header: 'LAST BIDDER',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => {
      return row?.latestBid?.bidType === 'OFFER'
        ? row?.latestBid?.offer?.grades?.map((item) => {
            return (
              <Badge key={item.id} color="primary">
                {item?.name}
              </Badge>
            );
          })
        : row?.latestBid?.demand?.grades?.map((item) => {
            return (
              <Badge key={item.id} color="primary">
                {item?.name}
              </Badge>
            );
          });
    },
    header: 'GRADE',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: 'latestBid.status',
    header: 'STATUS',
    enableSorting: true,
    cell: ({ row }) => {
      const status = row?.original?.latestBid?.status;

      const getStatusLabel = (bidStatus) => {
        switch (bidStatus) {
          case 'BID_ACTIVE':
          case 'BID_IN_PROGRESS':
            return 'Active';
          case 'BID_EXPIRED':
            return 'Expired';
          case 'BID_ACCEPTED':
            return 'Accepted';
          case 'BID_REJECTED':
            return 'Rejected';
          case 'BID_WITHDRAWN':
            return 'Withdrawn';
          default:
            return status || 'Unknown';
        }
      };

      return getStatusLabel(status);
    },
  },
  {
    accessorFn: (row) => {
      return row?.latestBid?.bidType === 'OFFER' ? (
        <>
          <div className="mb-1 text-nowrap">
            {row?.latestBid?.offer?.city?.cityName
              ? row?.latestBid?.offer?.city?.cityName
              : row?.latestBid?.offer?.portsOfDischarge?.map(
                  (portOfDischarge) => {
                    return (
                      <div key={portOfDischarge?.id} className="me-1">
                        {`${portOfDischarge?.name},` || 'Not Available'}
                      </div>
                    );
                  },
                )}
          </div>
          <div className="font-manrope text-active">
            {row?.latestBid?.offer?.state?.stateName}
          </div>
        </>
      ) : (
        <>
          <div className="mb-1 text-nowrap">
            {row?.latestBid?.demand?.city?.cityName
              ? row?.latestBid?.demand?.city?.cityName
              : row?.latestBid?.demand?.portsOfDischarge?.map(
                  (portOfDischarge) => {
                    return (
                      <div key={portOfDischarge?.id} className="me-1">
                        {`${portOfDischarge?.name},` || 'Not Available'}
                      </div>
                    );
                  },
                )}
          </div>
          <div className="font-manrope text-active">
            {row?.latestBid?.demand?.state?.stateName}
          </div>
        </>
      );
    },
    header: 'LOCATION',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => {
      return row?.latestBid?.bidType === 'OFFER'
        ? `${NumberWithCommasFormat(row?.latestBid?.offer?.totalQty)} ${row?.latestBid?.offer?.actualQuantityUnit || row?.latestBid?.offer?.quantityUnit}`
        : `${NumberWithCommasFormat(row?.latestBid?.demand?.totalQty)} ${row?.latestBid?.demand?.actualQuantityUnit || row?.latestBid?.demand?.quantityUnit}`;
    },
    header: 'total QTY',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => {
      return row?.latestBid?.bidType === 'OFFER'
        ? `${NumberWithCommasFormat(row?.latestBid?.offer?.minimumQty)} ${row?.latestBid?.offer?.actualQuantityUnit || row?.latestBid?.offer?.quantityUnit} `
        : `${NumberWithCommasFormat(row?.latestBid?.demand?.minimumQty)} ${row?.latestBid?.demand?.actualQuantityUnit || row?.latestBid?.demand?.quantityUnit}`;
    },
    header: 'min. QTY',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },

  {
    accessorFn: (row) => {
      return (
        <div className="px-1 text-nowrap">
          {row?.latestBid?.bidType === 'OFFER'
            ? `${currencyToLocal(
                row?.latestBid?.offer?.rate,
                row?.latestBid?.rateUnit?.isoCurrencyCode,
              )}/${row?.latestBid?.offer?.quantityUnit}`
            : `${currencyToLocal(
                row?.latestBid?.demand?.rate,
                row?.latestBid?.rateUnit?.isoCurrencyCode,
              )}/${row?.latestBid?.demand?.quantityUnit}`}
        </div>
      );
    },
    header: 'rate',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => {
      const sourceData =
        row?.latestBid?.bidType === 'OFFER'
          ? row?.latestBid?.offer
          : row?.latestBid?.demand;
      const bidRateUnit =
        sourceData?.quantityUnit || row?.latestBid?.quantityUnit || '';
      return (
        <div className="px-1 text-nowrap">
          {`${currencyToLocal(
            row?.latestBid?.price,
            row?.latestBid?.rateUnit?.isoCurrencyCode,
          )}/${bidRateUnit}`}
        </div>
      );
    },
    cell: (info) => info.getValue(),
    header: 'Bid Rate',
    enableSorting: true,
  },
  {
    accessorFn: (row) => {
      const sourceData =
        row?.latestBid?.bidType === 'OFFER'
          ? row?.latestBid?.offer
          : row?.latestBid?.demand;
      const bidQtyUnit =
        sourceData?.actualQuantityUnit ||
        sourceData?.quantityUnit ||
        row?.latestBid?.quantityUnit ||
        '';
      return (
        <div className="px-1">
          {NumberWithCommasFormat(row?.latestBid?.quantity)} {bidQtyUnit}{' '}
        </div>
      );
    },
    cell: (info) => info.getValue(),
    header: 'bid Quantity',
    enableSorting: true,
  },
  {
    accessorFn: (row) => {
      return <DateFormatter dateTime={row?.latestBid?.bidExpireTime} />;
    },
    cell: (info) => info.getValue(),
    header: 'Bid Expire time',
    enableSorting: true,
  },
  { accessorKey: 'latestBid.bidType', header: 'Type', enableSorting: true },
];

const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;

  return `${day}/${month}/${year}, ${displayHours}:${minutes} ${ampm}`;
};

const resolveQuantityUnit = (sourceData, fallbackUnit = '') => {
  return (
    sourceData?.actualQuantityUnit ||
    sourceData?.quantityUnit ||
    fallbackUnit ||
    ''
  );
};

const resolveRateUnit = (sourceData, fallbackUnit = '') => {
  return (
    sourceData?.quantityUnit ||
    sourceData?.actualQuantityUnit ||
    fallbackUnit ||
    ''
  );
};

// Get status info - memoized computation
const getStatusInfo = (bidStatus, latestBid) => {
  const sourceData =
    latestBid?.bidType === 'OFFER' ? latestBid?.offer : latestBid?.demand;
  const qtyUnit = resolveQuantityUnit(sourceData, latestBid?.quantityUnit);
  const rateUnit = resolveRateUnit(sourceData, latestBid?.quantityUnit);
  switch (bidStatus) {
    case 'BID_ACTIVE':
    case 'BID_IN_PROGRESS':
      return {
        icon: '',
        label: 'Active',
        message: `Current Bid: ${currencyToLocal(latestBid?.price, latestBid?.rateUnit?.isoCurrencyCode)}/${rateUnit} | Expires: ${formatDateTime(latestBid?.bidExpireTime)}`,
        className: 'active',
      };
    case 'BID_ACCEPTED':
      return {
        icon: '✅',
        label: 'Bid Accepted',
        message: `Final Price: ${currencyToLocal(latestBid?.price, latestBid?.rateUnit?.isoCurrencyCode)}/${rateUnit} | Quantity: ${NumberWithCommasFormat(latestBid?.quantity)} ${qtyUnit} | Accepted on: ${formatDateTime(latestBid?.updatedAt)}`,
        className: 'accepted',
      };
    case 'BID_EXPIRED':
      return {
        icon: '⏰',
        label: 'Bid Expired',
        message: `Last Bid: ${currencyToLocal(latestBid?.price, latestBid?.rateUnit?.isoCurrencyCode)}/${rateUnit} | Expired on: ${formatDateTime(latestBid?.bidExpireTime)}`,
        className: 'expired',
      };
    case 'BID_COUNTER':
      return {
        icon: '⏰',
        label: 'BID_COUNTER',
        message: `Last Bid: ${currencyToLocal(latestBid?.price, latestBid?.rateUnit?.isoCurrencyCode)}/${rateUnit} | Expired on: ${formatDateTime(latestBid?.bidExpireTime)}`,
        className: 'counter',
      };
    case 'BID_WITHDRAWN':
      return {
        icon: '↩️',
        label: 'Bid Withdrawn',
        message: `Withdrawn by ${latestBid?.bidder?.entityName} | Withdrawn on: ${formatDateTime(latestBid?.updatedAt)}`,
        className: 'withdrawn',
      };
    case 'BID_REJECTED':
      return {
        icon: '❌',
        label: 'Bid Rejected',
        message: `Last Bid: ${currencyToLocal(latestBid?.price, latestBid?.rateUnit?.isoCurrencyCode)}/${rateUnit} | Rejected on: ${formatDateTime(latestBid?.updatedAt)}`,
        className: 'rejected',
      };
    default:
      return null;
  }
};

// Memoized BidItem Component
const BidItem = React.memo(({ bid }) => {
  const isSeller = bid?.bidderRole === 'SELLER';
  const sourceData = bid?.bidType === 'OFFER' ? bid?.offer : bid?.demand;
  const qtyUnit = resolveQuantityUnit(sourceData, bid?.quantityUnit);
  const rateUnit = resolveRateUnit(sourceData, bid?.quantityUnit);
  const bidderName =
    bid?.bidder?.entityName ||
    (bid?.bidder?.firstName && bid?.bidder?.lastName
      ? `${bid.bidder.firstName} ${bid.bidder.lastName}`
      : 'Unknown');
  const formatBidPrice = (price) => {
    if (price === null || price === undefined) return 'N/A';
    const numericPrice = Number(price);
    if (Number.isNaN(numericPrice)) return 'N/A';
    return numericPrice.toFixed(2);
  };

  return (
    <div className={`bid-item-v2 ${isSeller ? 'seller-bid' : 'buyer-bid'}`}>
      <div className="bidder-info">
        <div className="bidder-role">{isSeller ? 'Seller' : 'Buyer'}</div>
        <div className="bidder-name">{bidderName}</div>
      </div>

      <div className="bid-item-details-v2">
        <div className="bid-qty-rate-container">
          <div className="qty-section">
            <span className="qty-value-green">
              {NumberWithCommasFormat(bid?.quantity)}
            </span>
            <span className="unit-text">{qtyUnit}</span>
          </div>

          <div className="divider" />

          <div className="rate-section">
            <span className="rupee-symbol">₹</span>
            <span className="rate-value-green">
              {formatBidPrice(bid?.price)}/{rateUnit}
            </span>
          </div>
        </div>

        {bid?.createdAt && (
          <div className="bid-timestamp">
            {new Date(bid.createdAt).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })}
          </div>
        )}
      </div>
    </div>
  );
});

BidItem.displayName = 'BidItem';

// Memoized BidCardContent Component - Main Card with all logic
// eslint-disable-next-line react/no-multi-comp
const BidCardContent = React.memo(({ groupedBid }) => {
  const latestBid = groupedBid?.latestBid;
  const allBids = groupedBid?.allBids || [];
  const bidType = latestBid?.bidType;
  const isBidOffer = bidType === 'OFFER';

  // Compute values - no useMemo needed as component will re-render only when groupedBid changes
  const sellerData = isBidOffer
    ? latestBid?.offer?.trader
    : latestBid?.demand?.trader;
  const grades = isBidOffer
    ? latestBid?.offer?.grades
    : latestBid?.demand?.grades;
  const location = isBidOffer
    ? {
        city: latestBid?.offer?.city?.cityName,
        state: latestBid?.offer?.state?.stateName,
      }
    : {
        city: latestBid?.demand?.city?.cityName,
        state: latestBid?.demand?.state?.stateName,
      };
  const totalQty = isBidOffer
    ? latestBid?.offer?.totalQty
    : latestBid?.demand?.totalQty;
  const offerRate = isBidOffer
    ? latestBid?.offer?.rate
    : latestBid?.demand?.rate;
  const baseUnit = isBidOffer
    ? latestBid?.offer?.quantityUnit
    : latestBid?.demand?.quantityUnit;
  const actualUnit = isBidOffer
    ? latestBid?.offer?.actualQuantityUnit
    : latestBid?.demand?.actualQuantityUnit;
  const displayQtyUnit = actualUnit || baseUnit || '';
  const bidStatus = latestBid?.status;
  const statusInfo = getStatusInfo(bidStatus, latestBid);

  return (
    <div className="bid-card-v2">
      <div className="bid-content-grid">
        {/* LEFT SIDE */}
        <div className="bid-left-column">
          <div className="bid-info moin">
            <div className="grade-display">
              <span className="grade-name">{grades?.[0]?.name || 'Grade'}</span>
            </div>
            <span className="seller-name">{sellerData?.entityName}</span>
            <span className="seller-label">(Seller)</span>
          </div>

          <div className="bid-info-row">
            <div className="info-label-v2">Offer Qty</div>
            <span className="qty-value">
              {NumberWithCommasFormat(totalQty)} {displayQtyUnit}
            </span>
          </div>

          <div className="bid-info-row">
            <div className="info-label-v2">Rate</div>
            <span className="rate-value-highlight">
              ₹{offerRate?.toFixed(2)}/{baseUnit || displayQtyUnit}
            </span>
          </div>

          <div className="bid-info-row">
            <div className="info-label-v2">Location</div>
            <div className="location-display">
              <span className="location-city">{location.city}</span>
              <span className="location-state">{location.state}</span>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="bid-right-column">
          <div className="bids-header-v2">
            <span className="bids-title">ALL BIDS</span>
            <span className="bids-count-badge">{allBids.length}</span>
          </div>

          {/* SCROLL CONTAINER */}
          <div className="bids-scroll-container">
            {allBids.length > 0 ? (
              <>
                {allBids.map((bid) => (
                  <BidItem key={bid.id || `bid-${bid.createdAt}`} bid={bid} />
                ))}

                {statusInfo && (
                  <div className={`bid-status-summary ${statusInfo.className}`}>
                    <div className="status-summary-content">
                      <div className="status-icon">{statusInfo.icon}</div>
                      <div className="status-text">
                        <div className="status-label">{statusInfo.label}</div>
                        <div className="status-details">
                          {statusInfo.message}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="no-bids-message">
                <div className="no-bids-icon">📭</div>
                <div className="no-bids-text">No bids available</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

BidCardContent.displayName = 'BidCardContent';

// ============= OPTIMIZED CHILD BIDS COLUMNS =============

export const childBidsColumns = [
  {
    accessorKey: 'cardView',
    header: '',
    enableSorting: false,
    cell: ({ row }) => <BidCardContent groupedBid={row.original} />,
  },
];

export const INVOICE_STATUS = {
  INVOICE_UNPAID: 'Unpaid',
  PAID_PARTIAL: 'Partially paid',
  PAID_FULL: 'Fully paid',
};

export const invoicesListCategoryColumns = [
  { accessorKey: 'id', header: 'INVOICE ID', sort: true },
  {
    accessorKey: 'createdAt',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    header: 'DATE',
    sort: true,
  },
  {
    accessorFn: (row) => {
      return <div className="mb-1">{row?.order?.buyer?.tradeName}</div>;
    },
    header: 'BILLED TO',
    id: 'order.buyer.tradeName',
    enableSorting: true,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: 'invoiceStatus',
    header: 'PAYMENT',
    sort: true,
    cell: ({ row }) => (
      <div>{INVOICE_STATUS?.[row?.original?.invoiceStatus]}</div>
    ),
  },
  {
    accessorKey: 'total',
    header: 'AMOUNT',
    sort: true,
    cell: (cell) => {
      return <span>&#8377;{cell?.row?.original?.total}</span>;
    },
  },
  { accessorKey: 'actions', header: '', sort: true },
];

export const orderStatusColors = Object.freeze({
  LOADING: '#c71dff',
  PENDING: '#ffe100',
  DISPATCHED: '#f47000',
  IN_PROGRESS: '#692ef4',
  DELIVERED: '#e40000',
});

export const orderStatusLabel = Object.freeze({
  LOADING: 'Loading',
  PENDING: 'Pending',
  DISPATCHED: 'Dispatched',
  IN_PROGRESS: 'In_Progress',
  DELIVERED: 'Delivered',
});

export const BidOrderType = Object.freeze({
  OFFER: 'OFFER',
  DEMAND: 'DEMAND',
  ALL: 'ALL',
});

export const VENDOR_ORDER_TABS = {
  ALL: 'All',
  FULLY_PAID: 'Fully Paid',
  PARTIALLY_PAID: 'Partially Paid',
  PENDING: 'Pending',
};

export const VENDOR_ORDERS_TABS = {
  SOLD_AND_PURCHASE: 'Sold And Purchase',
  PAYMENT: 'Paid Payment',
};

export const VENDOR_ORDER_PAYMENT_TABS = {
  PARTIALLY_PAID: 'Partially Paid',
  FULLY_PAID: 'Fully Paid',
  UNPAID: 'Unpaid',
};

export const VENDOR_BIDS_TABS = {
  OFFER: 'Offer',
  MY_OFFER: 'My Offers',
  OTHER_OFFER: 'Other Offers',
  DEMAND: 'Demand',
  MY_DEMAND: 'My Demands',
  OTHER_DEMAND: 'Other Demands',
};

export const defaultDeleteFilter = {
  key: 'isDeleted',
  value: 'true',
  type: 'BOOLEAN',
  op: 'NEQ',
};

export const dynamicButtonHeading = (type) => {
  return type === ADD_EDIT_CONSTANT.EDIT ? 'Update' : 'Add';
};

export const invoicesColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },

  {
    accessorFn: (row) => {
      return <div className="mb-1">{row?.order?.buyer?.tradeName}</div>;
    },
    header: 'BILLED TO',
    id: 'order.buyer.tradeName',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },
  { accessorKey: 'id', header: 'INVOICE ID', enableSorting: true },
  {
    accessorKey: 'invoiceStatus',
    header: 'PAYMENT',
    cell: ({ row }) => (
      <div>{INVOICE_STATUS?.[row?.original?.invoiceStatus]}</div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'total',
    header: 'AMOUNT',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(
          row?.original?.total,
          row?.original?.rateUnit?.isoCurrencyCode,
        )}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'createdAt',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    header: 'DATE',
    enableSorting: true,
  },
];

export const quantityUnitData = [
  { id: 'KG', label: 'KG' },
  { id: 'MT', label: 'MT' },
];

export const currencyUnitData = [
  { id: 101, label: 'INR' },
  { id: 233, label: 'USD' },
];

export const orderStatus = [
  {
    LOADING: 'Loading',
    PENDING: 'Pending',
    DISPATCHED: 'Dispatched',
    IN_PROGRESS: 'InProgress',
    DELIVERED: 'Delivered',
    CANCELLED: 'Cancelled',
  },
];

export const PASSWORD_REGEX =
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{6,16}$/;

export const PASSWORD_REGEX_MESSAGE =
  'Password must contain at least one digit, one lowercase letter, one uppercase letter, one special character, and be between 6 and 16 characters long.';

export const modifiedUnderScore = (originalString) => {
  if (originalString) return originalString?.replace(/_/g, ' ');
  return originalString;
};

export const USER_ID = {
  CREATED_ID: 'createdByUserId',
  UPDATED_ID: 'updatedByUserId',
};

export const allowedUserChecker = (roles, allowedRoles) =>
  allowedRoles.some((allowedRole) =>
    roles?.some((role) => role.name === allowedRole),
  );

export const currentDateToEpoch = () => {
  return Math.floor(new Date().getTime() / 1000);
};

export const currentDatePlusDaysToEpoch = (days = 0) => {
  const currentDate = new Date();
  const futureDate = new Date(
    currentDate.getTime() + days * 24 * 60 * 60 * 1000,
  );
  return Math.floor(futureDate.getTime());
};

export const handlePaymentStatusColor = (value) => {
  if (value === 'FULLY_PAID') {
    return 'success';
  }
  if (value === 'UNPAID') {
    return 'reject';
  }
  return null;
};

export const handleStatusColor = (value) => {
  if (value === 'ACTIVE') {
    return 'success';
  }
  if (value === 'INACTIVE') {
    return 'reject';
  }
  return null;
};

export const handleKycStatusColor = (value) => {
  if (value === 'KYC_ACCEPTED') {
    return 'success';
  }
  if (value === 'KYC_REJECTED') {
    return 'reject';
  }
  return null;
};

export const handleTraderTypeColor = (value) => {
  if (value === 'SELLER') {
    return 'success';
  }
  if (value === 'TRADER') {
    return 'reject';
  }
  if (value === 'BUYER') {
    return 'warning';
  }
  return null;
};

export const isGstNumberAvailable = (gstNumber) => {
  if (!gstNumber) return false;

  const invalidGstValues = [
    'Not Available',
    'N/A',
    'NA',
    'null',
    'undefined',
    'not available',
    'n/a',
  ];

  return (
    !invalidGstValues.includes(gstNumber.toString().trim()) &&
    gstNumber.toString().trim().length > 0
  );
};

export const validateGstForKyc = (gstNumber) => {
  if (!gstNumber) {
    return false;
  }

  const gstStr = gstNumber.toString().trim();

  const invalidGstValues = [
    'Not Available',
    'N/A',
    'NA',
    'null',
    'undefined',
    'not available',
    'n/a',
    '',
    ' ',
    '-',
    '--',
    'null',
    'undefined',
  ];
  return !invalidGstValues.includes(gstStr) && gstStr.length > 0;
};
